import { Component } from 'src/utils';
import logoIcon from './../../../images/small-logo.png';
import houseIcon from './../../../images/house-icon.png';
import user from './../../../images/user.png';
import template from './edit.html';

@Component({
  controllerAs: 'editProfile',
  template
})

export default class EditProfile {
  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'spinnerService',
    'authService',
    '$timeout',
    'toaster',
    '$stateParams',
    '$window',
    '$uibModal',
    'APP'
  ];

  constructor($scope, $ngRedux, $state, $spinner, $auth, $timeout, $toaster, $stateParams, $window, $uibModal,  APP) {
    const disconnect = $ngRedux.connect(this.mapState)(this);
    this.$ngRedux = $ngRedux;
    this.$state = $state;
    this.$auth = $auth;
    this.$stateParams = $stateParams;
    this.$window = $window;
     this.APP = APP;
    this.toaster =  $toaster;
    this.$spinner = $spinner;
    this.logoIcon = logoIcon;
    this.houseIcon = houseIcon;
    this.user = user;
    this.$uibModal = $uibModal;
    // this.defaultLastName = 'MYWBU';
    this.init();
    this.$timeout = $timeout;
    $auth.getCountries().then(() => {
    $timeout(() => {
      
      this.getStates(this.detail.billingCountry.countryCode,"billingAddress",0);
      this.getStates(this.detail.shippingCountry.countryCode,"shippingAddress",0);
      this.validateShippingBillingAddress();
    },300); });
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    return {
      detail: state.auth.profile,
      shippingCountries: state.auth.countries,
      billingCountries: state.auth.countries
    };
  }

  getStates(country, type, time) {
    if(this.isCopyAsShipping){
      this.getStatesForShippingAddress(this.detail.billingCountry.countryCode,time);
      var billingCountry = angular.copy(this.detail.billingCountry);
      this.detail.shippingCountry=billingCountry;
    }

    switch (type) {
      case 'billingAddress':
        this.getStatesForBillingAddress(country,time);
        break;

      case 'shippingAddress':
        this.getStatesForShippingAddress(country,time);
        break;

      default: 
        break;

    }
 

  }
  init() {
    this.COUNTRIES = [
      { value: 'US', label: 'US' }
    ];
    this.STATES = [
      { value: 'AL', label: 'Alabama' },
      { value: 'AK', label: 'Alaska' },
      { value: 'AS', label: 'American Samoa' },
      { value: 'AZ', label: 'Arizona' },
      { value: 'AR', label: 'Arkansas' },
      { value: 'CA', label: 'California' },
      { value: 'CO', label: 'Colorado' },
      { value: 'CT', label: 'Connecticut' },
      { value: 'DE', label: 'Delaware' },
      { value: 'DC', label: 'District of Columbia' },
      { value: 'FM', label: 'Federated States of Micronesia' },
      { value: 'FL', label: 'Florida' },
      { value: 'GA', label: 'Georgia' },
      { value: 'GU', label: 'Guam' },
      { value: 'HI', label: 'Hawaii' },
      { value: 'ID', label: 'Idaho' },
      { value: 'IL', label: 'Illinois' },
      { value: 'IN', label: 'Indiana' },
      { value: 'IA', label: 'Iowa' },
      { value: 'KS', label: 'Kansas' },
      { value: 'KY', label: 'Kentucky' },
      { value: 'LA', label: 'Louisiana' },
      { value: 'ME', label: 'Maine' },
      { value: 'MH', label: 'Marshall Islands' },
      { value: 'MD', label: 'Maryland' },
      { value: 'MA', label: 'Massachusetts' },
      { value: 'MI', label: 'Michigan' },
      { value: 'MN', label: 'Minnesota' },
      { value: 'MS', label: 'Mississippi' },
      { value: 'MO', label: 'Missouri' },
      { value: 'MT', label: 'Montana' },
      { value: 'NE', label: 'Nebraska' },
      { value: 'NV', label: 'Nevada' },
      { value: 'NH', label: 'New Hampshire' },
      { value: 'NJ', label: 'New Jersey' },
      { value: 'NM', label: 'New Mexico' },
      { value: 'NY', label: 'New York' },
      { value: 'NC', label: 'North Carolina' },
      { value: 'ND', label: 'North Dakota' },
      { value: 'MP', label: 'Northern Mariana Islands' },
      { value: 'OH', label: 'Ohio' },
      { value: 'OK', label: 'Oklahoma' },
      { value: 'OR', label: 'Oregon' },
      { value: 'PW', label: 'Palau' },
      { value: 'PA', label: 'Pennsylvania' },
      { value: 'PR', label: 'Puerto Rico' },
      { value: 'RI', label: 'Rhode Island' },
      { value: 'SC', label: 'South Carolina' },
      { value: 'SD', label: 'South Dakota' },
      { value: 'TN', label: 'Tennessee' },
      { value: 'TX', label: 'Texas' },
      { value: 'UT', label: 'Utah' },
      { value: 'VT', label: 'Vermont' },
      { value: 'VI', label: 'Virgin Islands' },
      { value: 'VA', label: 'Virginia' },
      { value: 'WA', label: 'Washington' },
      { value: 'WV', label: 'West Virginia' },
      { value: 'WI', label: 'Wisconsin' },
      { value: 'WY', label: 'Wyoming' }
    ];
    if (this.detail.customer && this.detail.customer.dateOfBirth) {
      this.detail.customer.dateOfBirth = new Date(this.detail.customer.dateOfBirth);
    }
    this.$spinner.show('appSpinner');
    this.$auth.getUserProfile()
      .then(() => 
      {
       
        this.userEmail = this.detail.customer.email;
        this.detail.customer.dateOfBirth = new Date(this.detail.customer.dateOfBirth);
        // if(this.detail.customer.lastName==this.defaultLastName){
        //   this.detail.customer.lastName = '';
        // }
      })
      .finally(() => this.$spinner.hide('appSpinner'));
  }

  onZipKeyUp1() {
    this.mask1 = '99999';
    if (this.detail.shippingZipCode && this.detail.shippingZipCode.length > 5) {
      this.mask1 = '99999-9999';
    }
  }

  onZipKeyUp2() {
    this.mask2 = '99999';
    if (this.detail.customer.zipCode && this.detail.customer.zipCode.length > 5) {
      this.mask2 = '99999-9999';
    }
  }

  onZipKeyUp3() {
    this.mask3 = '99999';
    if (this.detail.billingZipCode && this.detail.billingZipCode.length > 5) {
      this.mask3 = '99999-9999';
    }
  }

  submit(form) {
    
    if (form.$invalid) {
      return;
    }
    var country = '';
    var state = '';
    var detail= this.detail;
    angular.forEach(this.shippingCountries, function(country1) {

       
      if (detail.shippingCountry.countryCode === country1.label) {

        country = {
          "id": parseInt(country1.value),
          "countryCode":country1.label,
          "name": country1.name
        };
        
        angular.forEach(country1.states, function(state1) {
        
          if (detail.shippingState.code === state1.value) {
            state = {
              "id": 1,
              "code": state1.value,
              "name": state1.label
            };
           
          }
        });
      }
    });
    this.detail.shippingCountry=country;
    this.detail.shippingState=state;
    country = '';
    state = '';
    this.detail.customer.email = this.userEmail;
    detail= this.detail;
    angular.forEach(this.billingCountries, function(country1) {

       
      if (detail.billingCountry.countryCode === country1.label) {

        country = {
          "id": parseInt(country1.value),
          "countryCode":country1.label,
          "name": country1.name
        };
        
        angular.forEach(country1.states, function(state1) {
        
          if (detail.billingState.code === state1.value) {
            state = {
              "id": 1,
              "code": state1.value,
              "name": state1.label
            };
           
          }
        });
      }
    });
    this.detail.billingCountry=country;
    this.detail.billingState=state;
    // if(this.detail.customer.lastName==null || this.detail.customer.lastName==''){
    //   this.detail.customer.lastName=this.defaultLastName;
    // }

    // Validating PO Box character in address 
    if(this.$auth.validatingPoBoxAddress(this.detail.store.postboxAddress, this.detail.shippingAddressLine1)){
      // this.toaster.pop('success', 'We do not deliver to PO Boxes. Please enter a street address.');
      return false;
    }
    
    let userDetail = {
      'phoneNumber': this.detail.phoneNumber,
      'customer': {
        'firstName': this.detail.customer.firstName,
        'lastName': this.detail.customer.lastName,
        'dateOfBirth': new Date(this.detail.customer.dateOfBirth).getTime(),
        'addressLine1': null,
        'addressLine2': null,
        'city': null,
        'state': {
          'code': null
        },
        'country': null,
        'zipCode': this.detail.customer.zipCode
      },
      'email': this.detail.customer.email,
      'billingAddressLine1': this.detail.billingAddressLine1,
      'billingAddressLine2': this.detail.billingAddressLine2,
      'billingCity': this.detail.billingCity,
      'billingState': this.detail.billingState,
      'billingCountry': this.detail.billingCountry,
      'billingZipCode': this.detail.billingZipCode,
      'shippingAddressLine1': this.detail.shippingAddressLine1,
      'shippingAddressLine2': this.detail.shippingAddressLine2,
      'shippingCity': this.detail.shippingCity,
      'shippingState': this.detail.shippingState,
      'shippingCountry': this.detail.shippingCountry,
      'shippingZipCode': this.detail.shippingZipCode
    };
    if (!this.detail.billingState) {
      userDetail.billingState = {
        'code': null
      };
    }
    if (!this.detail.shippingState) {
      userDetail.shippingState = {
        'code': null
      };
    }
    form.error = {};
    this.isUserUpdateLoading = true;

    // Resolving avalara address
    // this.avalaraResolveAddress(userDetail, this.detail.store);
    
    // check the below one if can implement for effiency
    this.$auth.avalaraResolveAddress(userDetail, this.detail.store)
    .then( resolveAddress => {
        console.log("ResolveAddress : ", resolveAddress);
        this.$auth.openPopUpForAddressResolve(userDetail,resolveAddress, 
          addResolved => {
            console.log("Call back function", addResolved);
            if(addResolved.isCanceled){
              console.log("Canceled");
              this.isUserUpdateLoading = false;
            } else {
              if(this.isCopyAsShipping){
                addResolved.billingAddressLine1= addResolved.shippingAddressLine1;
                addResolved.billingAddressLine2= addResolved.shippingAddressLine2;
                addResolved.billingCity=addResolved.shippingCity;
                if(addResolved.shippingCountry){
                  if(addResolved.shippingCountry.countryCode){
                    this.getStatesForBillingAddress(addResolved.shippingCountry.countryCode,1);
                    var billingCountry1 = angular.copy(this.detail.billingCountry);
                    addResolved.billingCountry=billingCountry1;
                  }
                }
                if(addResolved.shippingState){
                  var billingState1 = angular.copy(addResolved.shippingState);
                  addResolved.billingState=billingState1;
                }
                // this.detail.shippingState.code=this.detail.billingState.code;
                addResolved.billingZipCode=addResolved.shippingZipCode;
              }
              this.updateProfile(addResolved);
            }
          });
        // .then( addResolved => {
        //   console.log("Address Resolved : ", resolveAddress);
        //     this.updateProfile(addResolved);
        //     })
        // .catch( addNotResolved => {
        //   console.log("AddNotResolved : ", addNotResolved);
        // });
        console.log("This should not run first");
    })
    .catch( err => {
      console.log("Error in edit : ", err);
    });
  }

  syncedToday() {
    let syncDate = new Date(this.detail.customer.lastSyncDateTime);
    let currentDate = new Date();
    return syncDate.getDate() === currentDate.getDate();
  }

  isDscMember() {
    if (!this.detail.customer) return false;
    return this.detail.customer.dscId === 'C' && new Date() <= new Date(this.detail.customer.dscExpireDate);
  }

  isDscButExpired() {
    if (!this.detail.customer) return false;
    return this.detail.customer.dscId === 'C' && new Date() > new Date(this.detail.customer.dscExpireDate);
  }

  goToHomePage() {
    let storeName = '';
    if (this.$stateParams.storeName && this.$stateParams.storeName != this.APP.ORDER.ORDER_URL.browseUrl) {
      storeName = this.$stateParams.storeName;
    } else {
      if (this.detail.store && this.detail.store.storeName) {
        storeName = this.detail.store.storeURLName;
      } else {
        storeName = this.$auth.getGuestStoreDetail().storeName;
      }
    }
    if (storeName) {
      this.$window.location.href = '/' + storeName;
    } else {
      this.$state.go('home');

    }
  }

  copyToShippingAddress(){
    if(this.isCopyAsShipping){
      this.detail.shippingAddressLine1= this.detail.billingAddressLine1;
      this.detail.shippingAddressLine2=this.detail.billingAddressLine2;
      this.detail.shippingCity=this.detail.billingCity;
      if(this.detail.billingCountry){
        this.getStatesForShippingAddress(this.detail.billingCountry.countryCode,1);
        var billingCountry = angular.copy(this.detail.billingCountry);
        this.detail.shippingCountry=billingCountry;
      }
      if(this.detail.billingState){
        var billingState = angular.copy(this.detail.billingState);
        this.detail.shippingState=billingState;
      }
      // this.detail.shippingState.code=this.detail.billingState.code;
      this.detail.shippingZipCode=this.detail.billingZipCode;
    }
  }

    validateShippingBillingAddress(){
      console.log(this.detail.shippingCountry);
        console.log(this.detail.billingCountry);
    if(this.detail.shippingAddressLine1===this.detail.billingAddressLine1
    && this.detail.shippingAddressLine2===this.detail.billingAddressLine2
    && this.detail.shippingCity===this.detail.billingCity
    && this.detail.shippingZipCode===this.detail.billingZipCode
    && this.detail.shippingCountry.countryCode===this.detail.billingCountry.countryCode
    && this.detail.shippingState.code===this.detail.billingState.code){
      console.log("equ");
      this.isCopyAsShipping=true;
    } else {
      console.log("Not equ");
      this.isCopyAsShipping=false;
    }
  }

  copyAddressLine1(Address1,isCopyAsShipping){
    if(isCopyAsShipping){
      this.detail.shippingAddressLine1= Address1;
    }
  }

  copyAddressLine2(Address2,isCopyAsShipping){
    if(isCopyAsShipping){
      this.detail.shippingAddressLine2= Address2;
    }
  }

  copyCity(city,isCopyAsShipping){
    if(isCopyAsShipping){
      this.detail.shippingCity= city;
    }
  }

  copyCountry(countryCode,isCopyAsShipping){
    if(isCopyAsShipping){
      this.detail.shippingCountry.countryCode= countryCode;
      this.getStates(countryCode,"shippingAddress");
    }
  }

  copyState(stateCode,isCopyAsShipping){
    if(isCopyAsShipping){
      if(this.detail.shippingState){
      var billingState = angular.copy(this.detail.billingState);
      this.detail.shippingState.code=stateCode;
      }
      else {
        this.detail.shippingState={};
        this.detail.shippingState.code=stateCode;
      }
    }
  }

  copyZipCode(zipCode,isCopyAsShipping){
    if(isCopyAsShipping){
      this.detail.shippingZipCode= zipCode;
    }
  }

  getStatesForBillingAddress(country,time){
    if (this.detail&&time!==0) {
      if (this.detail.billingState) {
        this.detail.billingState.code = '';
        this.detail.billingZipCode = '';
      }
    }
    var billingStates = '';
    // console.log(this.billingCountries);
    angular.forEach(this.billingCountries, function(value) {
      
      if (country === value.label) {
        billingStates = value.states;
      }
    });

    this.billingStates = billingStates;
  }

  getStatesForShippingAddress(country,time){
    if (this.detail&&time!==0) {
      if (this.detail.shippingState) {
        this.detail.shippingState.code = '';
        this.detail.shippingZipCode = '';
      }
    }
    var shippingStates = '';
    // console.log(this.shippingCountries);
    angular.forEach(this.shippingCountries, function(value) {
      // console.log(country,"==",value.label);
      if (country === value.label) {
        shippingStates = value.states;
      }
    });

    this.shippingStates = shippingStates;
  }

  avalaraResolveAddress(userDetail, store) {
      console.log("Calling Resolve address : ", userDetail);
      // if(store.validateAddressType !== 'NOT_VALIDATE' && store.validateAddressType != this.detail.validatedAddressType){
          userDetail.store = store;
          this.$auth.avalaraResolveAddress(userDetail, store)
          .then( success => {
                console.log("Success validating : ", success);
                var $ctrl = this;
                $ctrl.userDetail = userDetail;
                $ctrl.success = success;
                var modalInstance;
                if(success.data){
                  modalInstance = this.$uibModal.open({
                  size: 'md',
                  template: '<div class="modal-header modalheaderbg btn-primary"><h5>Resolve Shipping Address</h5></div>' +
                    '<div class="modal-body" id="modal-body">' +
                    '<div class="container-fluid">' +
                    '<div class="col-md-12 error-text" ng-if="error.message">{{error.message}}</div>' +
                    '<div class="row">' +
            
                    `<div class="col-md-12">
                          <div class="col-md-12 mb-4" style="text-align: center;">
                            <h6><strong>From</strong></h6>
                          </div>
      
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingAddressLine1 ? user.shippingAddressLine1.trim() : '')}}
                          </div>
                          </div>
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingAddressLine2 ? user.shippingAddressLine2.trim() : '')}}
                          </div>
                          </div>
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">City</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingCity ? user.shippingCity.trim() : '')}}
                          </div>
                          </div>
      
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">State</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingState ? user.shippingState.code : '')}}
                          </div>
                          </div>
      
      
                          <div class="col-md-12">
                          <div class="col-md-5">
                            <label style="color: #b58150;font-weight: bold;">Zip</label>
                          </div>
                          <div class="col-md-7">
                            {{(user.shippingZipCode ? user.shippingZipCode.trim() : '')}}
                          </div>
                          </div>
      
                    </div>`
                    +
                    
                    `<div ng-if="isValidAddress">
                    <br>
                    <div class="col-md-12">
                    <div class="col-md-12 mb-4" style="text-align: center;">
                      <h6><strong>To</strong></h6>
                    </div>
      
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Address Line 1</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.addressLine1 ? selected.addressLine1.trim() : '')}}
                    </div>
                    </div>
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Address Line 2</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.addressLine2 ? selected.addressLine2.trim() : '')}}
                    </div>
                    </div>
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">City</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.city ? selected.city.trim() : '')}}
                    </div>
                    </div>
      
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">State</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.state ? selected.state.code : '')}}
                    </div>
                    </div>
      
      
                    <div class="col-md-12">
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Zip</label>
                    </div>
                    <div class="col-md-7">
                      {{(selected.zip ? selected.zip.trim() : '')}}
                    </div>
                    </div>
                    </div>
                    </div>

                    <div class="col-md-12" ng-if="!isValidAddress">
                    <br>
                    <div class="col-md-5">
                      <label style="color: #b58150;font-weight: bold;">Given Address not Validated with our records</label>
                    </div>
                    <div class="col-md-7">
                      {{summary}}
                    </div>
                    </div>
                    ` +

                    '</div>' +
                    '</div>' +
                    '<div class="modal-footer">' +
                    '<button  ng-if="isValidAddress" class="btn btn-primary m-l-1" type="button" ng-click="submit()" style="float: right;">Update</button>' +
                    '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="back()" style="float: left;">Use this address anyway</button>' +
                    '<button  ng-if="!isValidAddress" class="btn" type="button m-l-1" ng-click="fix()" style="float: right;">I will fix the address</button>' +
                    
                    '</div>',
                  controller: ['$scope', '$state', '$uibModalInstance',
                    function ($scope, $state, $uibModalInstance) {
                      $scope.error = { message: '' };
                      $scope.user = $ctrl.userDetail;
                      $scope.isValidAddress = false;
                      $scope.count = 1;
                      if($ctrl.userDetail.store.validateAddressType==='BOTH_BILL_SHIP'){
                        $scope.count = 2;
                      }
                      if($ctrl.success.data.resolutionQuality==='Intersection') {
                        $scope.isValidAddress = true;
                        if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
                          $scope.selected = $ctrl.success.data.shippingAddresstoResolve;
                        }
                        else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
                          $scope.selected = $ctrl.success.data.billingAddresstoResolve;
                        }
                      } else {
                        if($ctrl.userDetail.store.validateAddressType === 'Shipping'){
                          $scope.invalidDetails = $ctrl.success.data.shippingAddresstoResolve.details;
                          $scope.summary  = $ctrl.success.data.shippingAddresstoResolve.summary;
                        }
                        else if ($ctrl.userDetail.store.validateAddressType === 'Billing'){
                          $scope.invalidDetails = $ctrl.success.data.billingAddresstoResolve.details;
                          $scope.summary  = $ctrl.success.data.billingAddresstoResolve.summary;
                        }
                      }
                      $scope.submit = () => {
                        // $ctrl.$spinner.show('appSpinner');
                        console.log("It calls from submit");
                        $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
                        $scope.user.shippingAddressLine1 = $scope.selected.addressLine1;
                        // $scope.user.shippingAddressLine2 = $scope.selected.addressLine1;
                        $scope.user.shippingCity = $scope.selected.city;
                        $scope.user.shippingState.code = $scope.selected.state.code;
                        $scope.user.shippingCountry.code = $scope.selected.country.code;
                        $scope.user.shippingZipCode = $scope.selected.zip;
                        $uibModalInstance.close($scope.user);
                      };
                      $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                      $scope.back = () => {
                        $scope.user.validatedAddressType = $ctrl.userDetail.store.validateAddressType;
                        $uibModalInstance.close($scope.user);
                      };
                      $scope.fix = () => {
                        console.log("In fixing ");
                        $ctrl.isUserUpdateLoading = false;
                        $uibModalInstance.dismiss('cancel');
                        // $ctrl.$state.go('profile.edit');
                        // $uibModalInstance.close($scope.user);
                      };
                    }
                  ],
                  resolve: {
                  }
                });
                modalInstance.result.then(function (data) {
                    console.log('user clicked ok', data);
                    $ctrl.updateProfile(data);
                });
              }
            })
          .catch( error => {
            console.log("Didn't call service resolve address : ", error);
          });
  }

  updateProfile(userDetail){
    this.$spinner.show('appSpinner');
    this.$auth.updateUserProfile(userDetail, this.detail.userId)
      .then(() => {
        this.$spinner.hide('appSpinner');
        this.isUserUpdateLoading = false;
        if(this.detail.emailUpdated) {
          this.$auth.logout(this.detail);
        } else{
          this.$timeout(() => { this.$state.go('home'); },1000);
        }
        localStorage.removeItem('deliveryAddress');
        this.toaster.pop('success', 'Profile updated successfully');
      })
      .catch( err => { 
        this.$spinner.hide('appSpinner');
        this.isUserUpdateLoading = false;
        this.toaster.pop('success', err.data.message);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/user-profile/edit.js